angular.module('env.threejs.threejsExporter', [])

    // Service to export geometry as file
    .service('threejsExporter', function ($q, $http, $log) {
        var _this = this;

        _.extend(_this, {});

        return _this;

        function load(file) {

        }
    })

;
